import React from 'react';
import PulsingShift4Logo from '../PulsingShift4Logo';

const SUGGESTIONS = [
  "What's available in Canada?",
  'What products are In Pilot?',
  'What can I sell in the UK?',
];

type WelcomeScreenProps = {
  onSuggestionClick: (text: string) => void;
};

export function WelcomeScreen({ onSuggestionClick }: WelcomeScreenProps) {
  return (
    <div className="flex flex-col items-center justify-center h-full text-center text-gray-500 dark:text-gray-400 px-6">
      <PulsingShift4Logo size={80} className="mb-4" />
      <p className="text-base font-semibold mb-2 text-gray-700 dark:text-gray-300">
        Hi! I'm your Shift4 Product Assistant
      </p>

      <div
        className="w-full max-w-md mb-4 bg-orange-50 dark:bg-orange-900/20 border-l-4 border-orange-500 dark:border-orange-600 text-orange-800 dark:text-orange-300 p-3 rounded-r text-left"
        role="alert"
      >
        <p className="font-semibold text-sm mb-1">⚠️ Verify Before Using</p>
        <p className="text-xs">
          I'm still in training and may provide incomplete or inaccurate information. Always verify
          important details before sharing with customers.
        </p>
      </div>

      <p className="text-xs text-gray-400 dark:text-gray-500 mb-4">
        Try one of these to get started:
      </p>

      <div className="w-full max-w-md space-y-2">
        {SUGGESTIONS.map((suggestion, idx) => (
          <button
            key={idx}
            onClick={() => onSuggestionClick(suggestion)}
            className="w-full text-left px-4 py-2.5 text-sm bg-gray-50 dark:bg-gray-800 hover:bg-blue-50 dark:hover:bg-blue-900/30 border border-gray-200 dark:border-gray-700 hover:border-blue-300 dark:hover:border-blue-600 rounded-lg transition-all text-gray-700 dark:text-gray-300 hover:text-blue-700 dark:hover:text-blue-400"
          >
            {suggestion}
          </button>
        ))}
      </div>
    </div>
  );
};
